import MonthSelector from './MonthSelector.view';

export default MonthSelector;
